import { Button, Loading } from '@spoiler-alert/ui-library';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { createUseStyles } from 'react-jss';
import { InviteService, TitleService } from '../../services';
import { Breadcrumbs } from '../../store';

const useStyles = createUseStyles({
  welcome: {
    textAlign: 'left',
    width: 400,
    fontSize: '16px',
    margin: 'auto',
  },
});

const ConfirmInvite = ({ match }) => {
  const classes = useStyles();
  const token = match.params.token;

  const [inviteDetails, setInviteDetails] = useState(null);
  const [confirmationSent, setConfirmationSent] = useState(localStorage.getItem('inviteConfirmed') === token || false);

  useEffect(() => {
    TitleService.setTitles('Confirm Invite');
    Breadcrumbs.set([
      {
        url: `/confirm-invite/${token}`,
        title: 'Confirm Invite',
      },
    ]);
    if (!confirmationSent) {
      InviteService.getInvite(token)
        .then((res) => res.json())
        .then((details) => setInviteDetails({ ...details, valid: true }))
        .catch(() => setInviteDetails({ valid: false }));
    }
  }, [token, confirmationSent]);

  const handleVerify = () => {
    InviteService.sendConfirmation(token).then(() => {
      setConfirmationSent(true);
      localStorage.setItem('inviteConfirmed', token);
    });
  };

  return (
    <div>
      {confirmationSent ? (
        <div className={classes.welcome}>
          <h4>Thank you for confirming!</h4>
          <p>You can now close this window and check your email for the next step.</p>
        </div>
      ) : (
        <Loading loading={inviteDetails === null}>
          {inviteDetails?.valid ? (
            <div className={classes.welcome}>
              <h4>Welcome {inviteDetails.firstName}!</h4>
              <p>
                Click the button below to send a confirmation email to your inbox. You&rsquo;ll have <strong>10 minutes</strong> to complete the
                signup process or the link will expire. Please do not forward this to anyone.
              </p>
              <Button onClick={handleVerify}>Send Confirmation Email</Button>
            </div>
          ) : (
            <h4>Invite link invalid</h4>
          )}
        </Loading>
      )}
    </div>
  );
};

ConfirmInvite.propTypes = {
  history: PropTypes.object,
  match: PropTypes.object,
};

export default ConfirmInvite;
